// extracted by mini-css-extract-plugin
module.exports = {"module":"ModalFullScreen_module__JyQ6V","container":"ModalFullScreen_container__dI1sO","closeButton":"ModalFullScreen_closeButton__AoMZY"};